<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Create New Program</CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="8">
              <div role="group" class="form-group form-row">
                <label class="col-form-label col-sm-3 multiselect-label-required">Asal </label>
                <div class="col-sm-9">
                  <multiselect
                    v-model="originRoutes"
                    :options="optionsAreaOrigin"
                    placeholder="Pilih asal"
                    :searchable="true"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :multiple="false"
                    :allow-empty="false"
                    :show-labels="false"
                    :show-no-options="false"
                    :class="{
                      'is-invalid': !validate.origin_routes_id.isValid,
                    }"
                    :custom-label="customLabel"
                    @search-change="handleSearchOrigin"
                    @input="handleOriginRouteCode"
                  >
                    <template #noResult>
                      <span>Area tidak ditemukan</span>
                    </template>
                  </multiselect>
                  <div
                    v-if="
                      !routesData.origin_routes_id &&
                      !validate.origin_routes_id.isValid &&
                      showErrorField
                    "
                    class="invalid-feedback d-block"
                  >
                    {{ validate.origin_routes_id.message }}
                  </div>
                </div>
              </div>
            </CCol>
          </CRow>

          <CRow class="form-group">
            <CCol :col="8">
              <div role="group" class="form-group form-row">
                <label class="col-form-label col-sm-3 multiselect-label-required">Tujuan </label>
                <div class="col-sm-9">
                  <multiselect
                    v-model="destinationRoutes"
                    :options="optionsAreaDestination"
                    placeholder="Pilih tujuan"
                    :searchable="true"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :multiple="false"
                    :allow-empty="false"
                    :show-labels="false"
                    :show-no-options="false"
                    :class="{
                      'is-invalid': !validate.destination_routes_id.isValid,
                    }"
                    :custom-label="customLabel"
                    @search-change="handleSearchDestination"
                    @input="handleDestinationRouteCode"
                  >
                    <template #noResult>
                      <span>Area tidak ditemukan</span>
                    </template>
                  </multiselect>
                  <div
                    v-if="
                      !routesData.destination_routes_id &&
                      !validate.destination_routes_id.isValid &&
                      showErrorField
                    "
                    class="invalid-feedback d-block"
                  >
                    {{ validate.destination_routes_id.message }}
                  </div>
                </div>
              </div>
            </CCol>
          </CRow>

          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                label="Slug URL otomatis"
                class="mb-0 required is-invalid"
                type="text"
                required
                horizontal
                disabled
                placeholder="Slug URL otomatis"
                :value="routesData.slug"
                :isValid="validate.slug.isValid"
                :invalidFeedback="validate.slug.message"
                @change="handleSlug"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                label="Title Page"
                class="mb-0 required is-invalid"
                type="text"
                required
                horizontal
                placeholder="Title Page"
                :value="routesData.title"
                :isValid="validate.title.isValid"
                :invalidFeedback="validate.title.message"
                @change="handleTitle"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                label="Meta Description"
                class="mb-0 required is-invalid"
                type="text"
                required
                horizontal
                placeholder="Meta Description"
                :value="routesData.meta_description"
                :isValid="validate.meta_description.isValid"
                :invalidFeedback="validate.meta_description.message"
                @change="handleMetaDescription"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                label="Status"
                :options="optionsActiveStatus"
                required
                class="required"
                horizontal
                placeholder="Pilih status"
                :value="routesData.status"
                :isValid="validate.status.isValid"
                :invalidFeedback="validate.status.message"
                @change="handleStatus"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInputFile
                label="Meta Image"
                class="required"
                horizontal
                type="file"
                @change="handleImageIllustration"
              />
              File size should be below 250KB.
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <img class="image-ilustrasi" id="myImg" v-if="routesData.image_illustration" :src="routesData.image_illustration" />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="$router.go(-1)">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton
                color="success"
                class="float-right"
                @click="handleSave()"
              >
                Save
              </CButton>
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import Multiselect from "vue-multiselect";
import RoutesUseCase from "./app/usecase/index.js";
import debounce from "lodash/debounce";

export default {
  name: "ProgramCreate",
  components: { Multiselect },
  data() {
    return {
      originRoutes: null,
      destinationRoutes: null,
      originSearchQuery: "",
      destinationSearchQuery: "",
      routesData: {
        origin_routes_id: "",
        destination_routes_id: "",
        slug: "",
        title: "",
        meta_description: "",
        status: "active",
        image_illustration: null,
        image_illustrationUrl: null,
      },
      optionsAreaOrigin: [],
      optionsAreaDestination: [],
      optionsActiveStatus: [
        { label: "ACTIVE", value: "active" },
        { label: "INACTIVE", value: "inactive" },
      ],

      showErrorField: false,
      fixedPrefix: "cek-ongkir-",
    };
  },
  computed: {
    validate() {
      return {
        origin_routes_id: {
          isValid: this.checkIsValid(this.routesData.origin_routes_id),
          error: !this.routesData.origin_routes_id,
          message: "Area asal harus diisi",
        },
        destination_routes_id: {
          isValid: this.checkIsValid(this.routesData.destination_routes_id),
          error: !this.routesData.destination_routes_id,
          message: "Area tujuan harus diisi",
        },
        slug: {
          isValid: this.checkIsValid(this.routesData.slug),
          error: !this.routesData.slug,
          message: "Slug harus diisi",
        },
        title: {
          isValid: this.checkIsValid(this.routesData.title),
          error: !this.routesData.title,
          message: "Title harus diisi",
        },
        meta_description: {
          isValid: this.checkIsValid(this.routesData.meta_description),
          error: !this.routesData.meta_description,
          message: "Meta description harus diisi",
        },
        status: {
          isValid: this.checkIsValid(this.routesData.status),
          error: !this.routesData.status,
          message: "Status harus diisi",
        },
        image_illustration: {
          isValid: this.checkIsValid(this.routesData.image_illustration),
          error: !this.routesData.image_illustration,
          message: "Meta image harus diisi",
        },
      };
    },
  },
  methods: {
    handleImageIllustration(value) {
      const file = value[0];
      this.routesData.image_illustration = URL.createObjectURL(file);
      this.routesData.image_illustrationUrl = file;
    },
    // validation
    checkIsValid(val) {
      return this.showErrorField && !val ? false : null;
    },

    // form change handlers
    handleSearchOrigin: debounce(function (item) {
      if (item === "") return;
      this.originSearchQuery = item;
      this.getLocations(this.originSearchQuery, "origin");
    }, 300),
    handleSearchDestination: debounce(function (item) {
      if (item === "") return;
      this.destinationSearchQuery = item;
      this.getLocations(this.destinationSearchQuery, "destination");
    }, 300),
    handleOriginRouteCode(item) {
      this.routesData.origin_routes_id = item.value;
      this.routesData.slug = this.generateSlugBySelectedArea();
    },
    handleDestinationRouteCode(item) {
      this.routesData.destination_routes_id = item.value;
      this.routesData.slug = this.generateSlugBySelectedArea();
    },
    handleSlug(value) {
      this.routesData.slug = value;
    },
    handleTitle(value) {
      this.routesData.title = value;
    },
    handleMetaDescription(value) {
      this.routesData.meta_description = value;
    },
    handleStatus(event) {
      this.routesData.status = event.target.value;
    },
    handleSave() {
      let err = [];
      this.showErrorField = true;

      if (this.validate.origin_routes_id.error) {
        err.push(this.validate.origin_routes_id.message);
      }
      if (this.validate.destination_routes_id.error) {
        err.push(this.validate.destination_routes_id.message);
      }
      if (this.validate.slug.error) {
        err.push(this.validate.slug.message);
      }
      if (this.validate.title.error) {
        err.push(this.validate.title.message);
      }
      if (this.validate.meta_description.error) {
        err.push(this.validate.meta_description.message);
      }
      if (this.validate.status.error) {
        err.push(this.validate.status.message);
      }
      if (this.validate.image_illustration.error) {
        err.push(this.validate.image_illustration.message);
      }

      if (err.length > 0) {
        this.$swal.fire({
          icon: "error",
          html: `
            <h3>Terjadi kesalahan</h3>
            <ul style="text-align:left;">
              ${err.map((e) => `<li>${e}</li>`).join("")}
            </ul>
          `,
        });
      } else {
        this.processSave();
      }
    },

    // fetching
    async getLocations(query, input) {
      try {
        const formattedQuery = `q=${encodeURIComponent(query)}`;
        const { data, err } = await RoutesUseCase.getLocations(formattedQuery);
        if (err || data.length == 0) {
          this.err = err;
        } else {
          if (data) {
            if (input === "origin") {
              this.optionsAreaOrigin = this.generateOptionsFromData(data);
            } else if (input === "destination") {
              this.optionsAreaDestination = this.generateOptionsFromData(data);
            } else {
              this.optionsAreaOrigin = this.generateOptionsFromData(data);
              this.optionsAreaDestination = this.generateOptionsFromData(data);
            }
          }
        }
      } catch (err) {
        await this.$swal.fire({
          icon: "error",
          text: err,
        });
      }
    },
    async processSave() {
      await this.$swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: async () => {
          this.$swal.showLoading();
          try {
            const { err } = await RoutesUseCase.saveOne(
              this.generateFormData()
            );
            if (err) {
              this.$swal.close();
              await this.$swal.fire({
                icon: "error",
                text: err,
              });
            } else {
              this.$swal.close();
              await this.$swal.fire({
                icon: "success",
                text: "Routes saved",
              });
              this.$router.push({ path: `/management/routes` });
            }
          } catch (err) {
            this.$swal.close();
            await this.$swal.fire({
              icon: "error",
              text: err,
            });
          }
        },
      });
    },

    // generator
    generateSlugBySelectedArea() {
      if (
        this.routesData.origin_routes_id === "" ||
        this.routesData.destination_routes_id === ""
      ) {
        return "";
      }

      // get origin label where origin_routes_id = this.routesData.origin_routes_id
      const origin = this.optionsAreaOrigin.find(
        (item) => item.value === this.routesData.origin_routes_id
      ).label;
      const destination = this.optionsAreaDestination.find(
        (item) => item.value === this.routesData.destination_routes_id
      ).label;

      const clean = (str) =>
        str
          .replace(/\([^)]*\)/g, "")
          .replace(/,/g, "")
          .trim()
          .toLowerCase()
          .replace(/\s+/g, "-");

      return `${this.fixedPrefix}${clean(origin)}-ke-${clean(destination)}`;
    },
    customLabel({ label, _value }) {
      return `${label}`;
    },
    generateFormData() {
      const formData = new FormData()
      formData.append("origin_routes_id", this.routesData.origin_routes_id)
      formData.append("destination_routes_id", this.routesData.destination_routes_id)
      formData.append("slug", this.routesData.slug)
      formData.append("title", this.routesData.title)
      formData.append("meta_description", this.routesData.meta_description)
      formData.append("status", this.routesData.status)
      formData.append("image_illustration", this.routesData.image_illustrationUrl)
      return formData
      
      // const payload = {
      //   origin_routes_id: this.routesData.origin_routes_id,
      //   destination_routes_id: this.routesData.destination_routes_id,
      //   slug: this.routesData.slug,
      //   title: this.routesData.title,
      //   meta_description: this.routesData.meta_description,
      //   status: this.routesData.status,
      // };

      // return payload;
    },
    generateOptionsFromData(data) {
      return data.map((item) => {
        return {
          label: item.route_code,
          value: item.route_id,
        };
      });
    },
  },
  mounted() {
    this.getLocations("");
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css?family=Poppins&display=swap");
@import "./Routes.css";
.image-ilustrasi {
  height: 120px;
}
@media(min-width:768px) {
  .image-ilustrasi {
    height: 200px;
    margin-left: 25%;
  }
}
</style>
<style>
.form-group.required .col-form-label::after, .multiselect-label-required::after {
  content: "*";
  color: red;
}
.form-row.required .col-form-label::after {
  content: "*";
  color: red;
}
</style>
